import './Loader.css'

export default () => {
    return (
        <div className="loader_container">
            <span className="loader"></span>
        </div>
    )
}